/*
 * File: form-dynamic-tree-select.ts
 * File Created: 2024-06-27 01:29:11
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-28 07:53:01
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop, Watch } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import { PropInnateSync } from "@root/core/vue-props";
import {
    IFormComponentAttr,
    IFormValidateResult,
    createRequiredValidator,
} from "../../core/lib/core";
import { IQuickUnit } from "@root/core/utilities/quick-helper";
import { makeRequiredValidator } from "@root/core/decorators/make-validator";

@Component
export class FormDynamicTreeSelect extends BaseFormComponent {
    @PropInnateSync("value", { type: String, default: undefined })
    innateValue!: String | undefined;

    @Prop({ type: Array, required: false })
    quicks!: IQuickUnit[];

    @Prop({ type: Object, required: false })
    params: NonNullable<any> | undefined;

    /// private helpers
    // required validation for tree select
    @makeRequiredValidator({
        validator: (o) =>
            !(
                o.value === "" ||
                o.value == null ||
                /// addition: should contain "id"
                !/\"id\"\:/.test(o.value) ||
                (Array.isArray(o.value) && o.value.length == 0)
            ),
    })
    defaultRequired() {
        return undefined;
    }
}
export default FormDynamicTreeSelect;
